import ParseHTMLString from './ParseHTMLString';
export function shouldAutoplay(iframeSrc) {
    // Do NOT autoplay if it's from Open University or similar domains
const blockAutoplayDomains = ['player.open.ac.uk', 'media-podcast.open.ac.uk'];
    try {
        const url = new URL(iframeSrc);
        return !blockAutoplayDomains.some(domain => url.hostname.includes(domain));
    } catch (e) {
        return true; // fallback to autoplay if URL can't be parsed
    }
}

export function IsEmpty(value)
{
    return value === undefined || value === null || value.length === 0 || value === '<p><br></p>'; 
}

export function IsEmptyArray(contentItemWithArray)
{
    return (!(contentItemWithArray && Array.isArray(contentItemWithArray.value) && contentItemWithArray.value.length > 0));
}

// Loop through subject areas and find the sub-category that matches the value we're passing in 
// e.g. If we pass in "Nature" as the sub-category, find which subject area this belongs to and return the subject area title
export function FindSubjectAreaForCategory(subjectAreas, subCategory)
{
    var subjectAreaTitle = "";

    subjectAreas.forEach(node => {
        node["node"].elements["sub_categories_list"].value.forEach(category => {
            if (category.elements.category_name.value === subCategory)
            {
                subjectAreaTitle = node["node"].elements["title"].value;

                return subjectAreaTitle;
            }
        });
    });

    return subjectAreaTitle;
}

// Takes input html and removes tags e.g. "<p>This is a test</p>" returns "This is a test"
export function FindHtmlInnerText(inputHtml)
{
    const regex = /(<[^>]+>)/g;
    var innerText = inputHtml.replace(regex, "");

    return innerText;
}

export function SetVideoTitle(iFrameText, videoTitle)
{
    // Video title has not been set up in Kontent, so just return original iFrame content
    if (IsEmpty(videoTitle))
    {
        return iFrameText;
    }

    // Convert the iFrame text to an html element
    var parser = new DOMParser();
    var doc = parser.parseFromString(iFrameText, 'text/html'); 

    // Just double check that iframe tag exists (it should!)
    if (doc.body.getElementsByTagName('iframe')[0] !== undefined)
    {
        // Add/Update from the title field passed in
        doc.body.getElementsByTagName('iframe')[0].setAttribute("title", videoTitle);

        return doc.body.innerHTML;
    }

    return iFrameText;
}

// Is this a title, text and image layout?
export function IsTitleTextImage(layoutType)
{
    if (layoutType === "layout_title_text_image")
    {
        return true;
    }

    return false;
}

// Is this a quiz layout?
export function IsQuizLayout(layoutType)
{
    if (layoutType === "layout___quiz")
    {
        return true;
    }
    
    return false;
}

// Is this a video playlist layout?
export function IsVideoPlaylistLayout(layoutType)
{
    if (layoutType === "layout___video_playlist")
    {
        return true;
    }
    
    return false;
}

// Is this a video playlist layout?
export function IsCarouselLayout(layoutType)
{
    if (layoutType === "layout___carousel")
    {
        return true;
    }
    
    return false;
}

export function IsCurrentDateBetweenDates(StartDate, EndDate)
{
    // for information on Moment - https://momentjs.com/docs/
    var moment = require('moment');
    var currentDate = new Date();   
    if (moment(currentDate).isBetween(StartDate, EndDate, 'minute', []))
    {
        return true;
    }
    
    return false;
}

// Construct programme page url. If programme page url does not contain '/' then we get the path created in gatsby-node.js
export function GenerateProgrammePageUrl(allPages, programmePageUrl)
{
    let generatedProgrammePageUrl = programmePageUrl;

    if (IsEmpty(allPages))
        return generatedProgrammePageUrl;

    // We only need to get the generated path (performed in gatsby-node.js) if the programme page url does not contain a / character
    if (programmePageUrl.indexOf("/") < 0)
    {

       /*allPages.nodes.forEach(node => {
            // Console.log the slug name if slug contains the word 'linford'.
            if (node.pageContext.slug?.includes("linford")) {
                console.log("ppURL="+programmePageUrl);
                console.log(node.pageContext.slug === programmePageUrl);
                console.log("path="+node.path);
                console.log(node);
            }
        } );
        */

        // Filter the array (matching slug on programme page url passed in) and get the path name for that record
        const programmePagePath = allPages.nodes.filter(node => node.pageContext.slug === programmePageUrl)[0].path;

        if (!IsEmpty(programmePagePath))
        {
            generatedProgrammePageUrl = programmePagePath;
        }
    }

    return generatedProgrammePageUrl;
}


export function formatDateMonthYear(dateToFormat)
{
    // for information on Moment - https://momentjs.com/docs/
    var moment = require('moment');
       
    dateToFormat = moment(dateToFormat).format('MMMM yyyy');

    return dateToFormat;
}


export function removeParagraphTags(textString)
{
    if (!IsEmpty(textString))
    {
        textString = textString.replace(/(<([^>]+)>)/ig, "");
    }

    return textString;
}

export function cleanParagraphs(textString)
{
    if (!IsEmpty(textString))
    {
        textString = textString.replace(/<\/?[^>]+(>|$)/g, "");
        textString = textString.replace(/&nbsp;/g, " ");
        textString = textString.replace(/&amp;/g, "&");
        textString = textString.replace(/&quot;/g, "\"");
        textString = textString.replace(/&apos;/g, "'");
        textString = textString.replace(/&lt;/g, "<");
        textString = textString.replace(/&gt;/g, ">");
        textString = textString.replace(/&ldquo;/g, "\"");
        textString = textString.replace(/&rdquo;/g, "\"");  
        textString = textString.replace(/&rsquo;/g, "'");
        textString = textString.replace(/&lsquo;/g, "'");   
        textString = textString.replace(/&mdash;/g, "-");
        textString = textString.replace(/&ndash;/g, "-");   
        textString = textString.replace(/&hellip;/g, "...");
        textString = textString.replace(".", ". ");
    }

    return textString;
}

export const extractIframeSrc = (htmlString) => {
    if (!htmlString) return null;
    const match = htmlString.match(/<iframe[^>]+src=["']([^"']+)["']/i);
    return match ? match[1] : null;
};

export const getVideoThumbnail = async (iframeSrc) => {
    const youtubeRegex = /youtube\.com\/embed\/([a-zA-Z0-9_-]+)/;
    const vimeoRegex = /vimeo\.com\/video\/(\d+)/;

    if (youtubeRegex.test(iframeSrc)) {
        const match = iframeSrc.match(youtubeRegex);
        const videoId = match[1];
        return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    }

    if (vimeoRegex.test(iframeSrc)) {
        const match = iframeSrc.match(vimeoRegex);
        const videoId = match[1];

        const oembedUrl = `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`;

        try {
            
            const response = await fetch(oembedUrl);
            const data = await response.json();
            return data.thumbnail_url;
        } catch (error) {
            console.error("Error fetching Vimeo thumbnail:", error);
            return null;
        }
    }

    // Open University
    const ouMatch = iframeSrc.match(/player\.open\.ac\.uk\/embed\/([a-z0-9]+)/i);
    if (ouMatch) {
        const videoId = ouMatch[1];
        // return `https://player.open.ac.uk/embed/${videoId}`; //returning the same URL as thumbnail

        try {
            // using Microlink API to get thumbnail
            const response = await fetch(`https://api.microlink.io?url=${encodeURIComponent(iframeSrc)}&screenshot.omitBackground=true&screenshot.clip.x=0&screenshot.clip.y=0&screenshot.clip.width=1280&screenshot.clip.height=720`);
            const data = await response.json();
            return data.data?.screenshot?.url || null; // returns thumbnail URL if available
        } catch (error) {
            console.error("Error fetching OU thumbnail:", error);
            return null;
        }
    }

    return null;
};
